var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckGreenLigth({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6558_1437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 5.53993V5.99993C10.9991 7.07814 10.65 8.12727 10.0044 8.99084C9.35884 9.85442 8.4514 10.4862 7.41743 10.7919C6.38347 11.0976 5.27838 11.0609 4.26699 10.6872C3.2556 10.3136 2.39208 9.62298 1.80524 8.71846C1.21839 7.81395 0.939651 6.74396 1.01059 5.66809C1.08154 4.59221 1.49836 3.56809 2.1989 2.74847C2.89943 1.92884 3.84615 1.35762 4.89785 1.12001C5.94955 0.882387 7.04989 0.991101 8.03476 1.42993",
    stroke: "#2D7032",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 2L6 7.005L4.5 5.505",
    stroke: "#2D7032",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6558_1437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreenLigth);
export default __webpack_public_path__ + "static/media/check-green-ligth.3ce4d2c9e568a92526d32600d2c7b473.svg";
export { ForwardRef as ReactComponent };